// @ts-strict

import { Component, Input } from '@angular/core';
import { ISingleCampaign, CampaignConfigurationModalTypes, SpecialCampaignData } from '@app/core/models/core-models';
import { IEditIVRData, IVRConfigurationData } from '@app/core/services/ivr-configurations/ivr-configurations.service.types';
import { IPPIImgFieldValue } from '@services/url-address-config/url-address-config.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ivr-ppi-modal-container',
  templateUrl: './ivr-ppi-modal-container.component.html',
  styleUrls: ['./ivr-ppi-modal-container.component.scss']
})
export class IvrPpiModalContainerComponent {
  @Input() modalDescriptionName?: string;
  @Input() modalTitle?: string;
  @Input() modalType?: CampaignConfigurationModalTypes;
  @Input() configurationData?: IVRConfigurationData | IEditIVRData | IPPIImgFieldValue[];
  @Input() campaignData?: ISingleCampaign | SpecialCampaignData;
  @Input() canCreateNumberConfig = false;
  @Input() duplicateModal?: string;

  constructor(public activeModal: NgbActiveModal) {}

  public closeModal(): void {
    this.activeModal.close();
  }
}
